import * as React from "react";
import { Layout, Metatags } from "../../../components";
import { Link } from "gatsby";

const Index = ({ serverData: { blog } }) => {
  const [mediaData, setMediaData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [blogs, setBlogs] = React.useState([]);

  const timeDuration = `${blog?.content?.rendered?.split(" ")?.length / 90}`;
  const percentageTime = timeDuration?.split(".")[0];
  const slug = blog?.slug;
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  React.useEffect(() => {
    fetch(`${process.env.GATSBY_BLOGS_API_URL}/index.php/wp-json/wp/v2/posts`)
      .then((response) => response.json())
      .then((data) => {
        setBlogs(data);
      })
      .catch((error) => {
        console.log(error);
        return setLoading(true);
      });

    setTimeout(() => {
      setLoading(false);
    }, 800);
  }, []);

  React.useEffect(() => {
    for (let i = 0; i < blogs.length; i++) {
      fetch(
        `${process.env.GATSBY_BLOGS_API_URL}/index.php/wp-json/wp/v2/media/${blogs[i].featured_media}`
      )
        .then((res) => res.json())
        .then((result) => {
          setMediaData((prevData) => [...prevData, result]);
        })
        .catch((error) => {
          console.log(error);
          return setLoading(true);
        });
    }
  }, [blogs]);

  React.useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Layout>
      <div className="py-5 mt-5 bg-white">
        <div className="container">
          <div className="small-container">
            <div className="mb-2">
              <h1 className="blogTitle fw-bold py-4">
                {blog?.title?.rendered}
              </h1>
              <img
                src={blog?.jetpack_featured_media_url}
                alt="alternative"
                className="w-100"
              />

              <div className="d-flex my-5">
                <img
                  src="/images/hanzala.webp"
                  alt="alternative"
                  className="rounded-circle me-3"
                  width={65}
                  height={65}
                />
                <div>
                  <p className="py-2">
                    <strong>Hanzala</strong>
                    <br />
                    {percentageTime} min read &nbsp;⋅&nbsp;
                    {`${months[new Date(blog?.date).getMonth()]} ${new Date(
                      blog?.date
                    ).getDate()}, ${new Date(blog?.date).getFullYear()}`}
                  </p>
                </div>
              </div>
            </div>

            <div
              className="blogcontent"
              dangerouslySetInnerHTML={{
                __html: blog?.content?.rendered,
              }}
            />

            <hr className="my-5" />

            <div className="d-flex justify-content-between align-items-center my-3">
              <h1 className="fw-bold fs-5">Recent Blogs</h1>
              <Link className="text-muted text-decoration-none" to="/blog/">
                See All
              </Link>
            </div>

            <div className="row">
              {(loading ? Array.from(new Array(2)) : blogs?.slice(0, 3))?.map(
                (blog, index) => {
                  if (!blog) {
                    return (
                      <div className="col-md-12 col-lg-6 mb-4" key={index}>
                        <div
                          className="rounded d-flex align-items-end skeleton"
                          style={{
                            height: "230px",
                          }}
                        ></div>
                      </div>
                    );
                  } else {
                    const blogImage = mediaData.find(
                      (media) => media.id === blog.featured_media
                    );

                    return blog?.slug === slug ? null : (
                      <Link
                        className="col-md-6 col-lg-6 mb-4 text-decoration-none"
                        to={`/blog/${blog?.slug}/`}
                        key={index}
                      >
                        <div className="blog_item zoom-out position-relative">
                          <img
                            className="w-100 h-100 rounded object-fit-cover"
                            src={blogImage?.source_url}
                            style={{ zIndex: "-10", minHeight: "280px" }}
                            alt="alternative"
                            loading="lazy"
                          />
                          <div className="position-absolute bottom-0">
                            <div className="mb-3 ms-3 me-3">
                              <h1 className="text-white fs-4 fw-bold">
                                {blog?.title?.rendered}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  }
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Index;

export const Head = ({ serverData: { blog } }) => {
  const metaData = blog?.acf;

  const schemaOrgJSONLD = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://hanzala.co.in/blog/${blog?.slug}/`,
    },
    headline: metaData?.page_title,
    description: metaData?.meta_description,
    image: blog?.jetpack_featured_media_url,
    author: {
      "@type": "Person",
      name: "Hanzala",
      url: "https://www.linkedin.com/in/hanzala-/",
    },
    publisher: {
      "@type": "Person",
      name: "Hanzala",
      logo: {
        "@type": "ImageObject",
        url: "https://hanzala.co.in/images/hanzala.webp",
      },
    },
    datePublished: blog?.date,
    dateModified: blog?.modified,
  };

  return (
    <Metatags
      title={metaData?.page_title}
      pageTitle={metaData?.page_title}
      metaTitle={metaData?.meta_title}
      description={metaData?.meta_description}
      imageUrl={blog?.jetpack_featured_media_url}
      schema={schemaOrgJSONLD}
      datePublished={blog?.date}
      dateModified={blog?.modified}
      type="article"
    />
  );
};

export async function getServerData({ params: { slug } }) {
  try {
    const res = await fetch(
      `${process.env.GATSBY_BLOGS_API_URL}/index.php/wp-json/wp/v2/posts?per_page=100&slug=${slug}`
    );

    if (!res.ok) {
      throw new Error(`Response failed`);
    }
    const blog = await res.json();

    if (blog) {
      return {
        props: { blog: blog[0] },
      };
    } else {
      return {
        props: { blog: null },
      };
    }
  } catch (error) {
    return {
      status: 500,
      headers: {},
      props: {},
    };
  }
}
